import React, { useState, useEffect } from 'react'
import DashboardSummary from '../DashboardSummaryNew';
import callPostApi from 'requests/PostRequests';
import * as Constants from '../../../requests/URLConstants';
import DashboardGroupedBarChart from '../DashboardGroupedBarChart';
import DashboardLineChart from '../DashboardLineChart';
import DashboardTable from '../DashboardTable';
import Breakfix from './Breakfix';
import DashboardCirclePackChart from '../DashboardCirclePackChart';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'
import * as IncidentManagementTables from './tableHeaders';
require("./_incident-management.scss");

const IncidentManagement = (props) => {
    
    const [performanceTrendLoading, setPerformanceTrendLoading] = useState(true);
    const [performanceTrendGraphData, setPerformanceTrendGraphData] = useState([]);
    const [performanceTrendTableData, setPerformanceTrendTableData] = useState([]);
    const [PerformanceTrendTableHeaders, setPerformanceTrendTableHeaders] = useState([]);
    const [reopenCountLoading, setReopenCountLoading] = useState(true);
    const [reopenCountSLAData, setReopenCountSLAData] = useState([]);
    const [reopenCountSLATable, setReopenCountSLATable] = useState([]);
    const [reopenCountDownloadabelData, setReopenCountDownloadabelData] = useState([]);
    const [incidentAgeingLoading, setIncidentAgeingLoading] = useState(true);
    const [incidentAgeingData, setIncidentAgeingData] = useState([]);
    const [incidentAgeingTable, setIncidentAgeingTable] = useState([]);
    const [incidentAgeingDownloadableData, setIncidentAgeingDownloadableData] = useState([]);
    const [breakfixLoading, setBreakfixLoading] = useState(true);
    const [breakfixData, setBreakfixData] = useState([]);
    const [severityWiseIncidentLoading, setSeverityWiseIncidentLoading] = useState(true);
    const [severityWiseIncidentData, setSeverityWiseIncidentData] = useState([]);
    const [severityWiseIncidentTableData, setSeverityWiseIncidentTableData] = useState([]);
    const [severityWiseIncidentDownloadableData, setSeverityWiseIncidentDownloadableData] = useState([]);
    const [incidentManagementSummaryLoading, setIncidentManagementSummaryLoading] = useState(true);
    const [incidentManagementSummary, setIncidentManagementSummary] = useState([]);
    const [incidentAgeingSummary, setIncidentAgeingSummary] = useState(0);
    const [reopenCountSummary, setReopenCountSummary] = useState({});

    useEffect(() => {
        getIncidentStatusViaSeverity(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getReopenCountSLA(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getIncidentBreakfix(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getIncidentPerformanceTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
        getIncidentAgeing(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.filterSelectionsSalesforce, props.workspace);
    }, [props.preferencesChanged])

    useEffect(() => {
        getIncidentManagementSummary();
    },[incidentAgeingSummary,incidentManagementSummary.reopenCountSummary,reopenCountSummary.percentage]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {

        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if(workspace === workspaces.automation_ops){
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client =  dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "incident_status": dashboardFilterSelectionsAutomation.incident_status,
                    "assignment_groups": dashboardFilterSelectionsAutomation.assigned_group,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval":{
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        else if (workspace === workspaces.salesforce_ops) {
            technology = ["Salesforce"];
            franchise = dashboardFilterSelectionsSalesforce.franchise;
            client = dashboardFilterSelectionsSalesforce.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    // "deployment_models": dashboardFilterSelectionsSalesforce.deployment_model,
                    // "business_competencies": dashboardFilterSelectionsSalesforce.competency,
                    // "incident_status": dashboardFilterSelectionsSalesforce.incident_status,
                    // "assignment_groups": dashboardFilterSelectionsSalesforce.assigned_group,
                    // "process_name": dashboardFilterSelectionsSalesforce.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace,
            };
        } 
        else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client =  dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "assignment_groups": dashboardFilterSelectionsSAP.assigned_group,
                    "incident_status": dashboardFilterSelectionsSAP.incident_status,
                    "automata_priority": dashboardFilterSelectionsSAP.priority
                },
                "interval":{
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }

        return bodyJSON;
    };

    const getIncidentManagementSummary = () => {
        let summary = [
            {
              title:DashboardConstants.IncidentAgeing,
              value: incidentAgeingSummary ? incidentAgeingSummary.toFixed(2) : 0
            },
            {
              title: DashboardConstants.ReopenCount,
              value: reopenCountSummary.reOpenCount  ? reopenCountSummary.reOpenCount : 0
            },
            {
              title: DashboardConstants.FirstTimeResolved,
              value: reopenCountSummary.percentage ? reopenCountSummary.percentage.toFixed(2) : 0,
              showPercent: true
            }
        ];
        setIncidentManagementSummary(summary);
    };

    const prepareSeverityWiseIncidentData = (response) => {
        let graphData = [];
        let tableData = [];
        let tableObj = {};
        let graphObj = {};
        let expandedItemObj = {};
        let expandedTable = [];
        let statusBucket = [];
        let downloadableData = [];
        if(response) {
            graphObj = {};
            statusBucket = [];
            let buckets = response.aggregations.incident_status.buckets;
            for(let i = 0; i < buckets.length; i++) {
                expandedTable = [];
                graphObj = {
                    name: buckets[i].key,
                    children: []
                };
                tableObj = {
                    id: i+1,
                    item: buckets[i].key,
                    count: buckets[i].doc_count,
                };
                statusBucket = buckets[i].incident_priority.buckets;
                for(let j = 0; j < statusBucket.length; j++) {
                    downloadableData.push({
                        group: buckets[i].key,
                        item: statusBucket[j].key,
                        count: statusBucket[j].doc_count
                    })
                    graphObj.children.push({name: statusBucket[j].key, value: statusBucket[j].doc_count});
                    expandedItemObj = {
                        id: j+1,
                        item: statusBucket[j].key,
                        count: statusBucket[j].doc_count
                    }
                    expandedTable.push(expandedItemObj);
                }
                graphData.push(graphObj);
                tableObj.expandedItems = expandedTable;
                tableData.push(tableObj);
            }
        }
        return {tableData,graphData,downloadableData};
    };

    const getIncidentStatusViaSeverity = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setSeverityWiseIncidentLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETINCIDENTSTATUSVIASEVERITY, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareSeverityWiseIncidentData(resp);
                setSeverityWiseIncidentData(formattedData.graphData);
                setSeverityWiseIncidentTableData(formattedData.tableData);
                setSeverityWiseIncidentDownloadableData(formattedData.downloadableData);
                setSeverityWiseIncidentLoading(false);
            }).catch((error) => {
                setSeverityWiseIncidentLoading(false);
            });
        }
    }

    const prepareReopenCountSLAData = (response) => {
        let graphData = [];
        let tableData = [];
        let tableObj = {};
        let graphObj = {};
        let expandedItemObj = {};
        let expandedTable = [];
        let summaryData = {
            reOpenCount: 0,
            percentage: 0
        };
        let downloadableData = [];
        let downloadableObj = {};
        let reOpenCount = 0, total = 0, percentage = 0;
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                expandedTable = [];
                total = 0;
                reOpenCount = 0;
                percentage = 0;
                tableObj = {
                    id: i+1,
                    item: buckets[i].key
                };
                for (let j = 0; j < buckets[i]["5"].buckets.length; j++) {
                    total = total + buckets[i]["5"].buckets[j].doc_count;
                    reOpenCount = reOpenCount + buckets[i]["5"].buckets[j]["re-open-count"].value;
                    graphObj = {
                        group: buckets[i]["5"].buckets[j].key,
                        key: buckets[i].key,
                        value: (((buckets[i]["5"].buckets[j].doc_count - buckets[i]["5"].buckets[j]["re-open-count"].value) *100 ) / buckets[i]["5"].buckets[j].doc_count).toFixed(2)
                    };
                    expandedItemObj = {
                        id: j+1,
                        item: buckets[i]["5"].buckets[j].key,
                        total: buckets[i]["5"].buckets[j].doc_count,
                        reOpenCount: buckets[i]["5"].buckets[j]["re-open-count"].value,
                        percentage: (((buckets[i]["5"].buckets[j].doc_count - buckets[i]["5"].buckets[j]["re-open-count"].value) *100 ) / buckets[i]["5"].buckets[j].doc_count).toFixed(2)
                    };
                    downloadableObj = {
                        priority: buckets[i]["5"].buckets[j].key,
                        item: buckets[i].key,
                        total: buckets[i]["5"].buckets[j].doc_count,
                        reOpenCount: buckets[i]["5"].buckets[j]["re-open-count"].value,
                        percentage: (((buckets[i]["5"].buckets[j].doc_count - buckets[i]["5"].buckets[j]["re-open-count"].value) *100 ) / buckets[i]["5"].buckets[j].doc_count).toFixed(2)
                    }
                    expandedTable.push(expandedItemObj);
                    graphData.push(graphObj);
                    downloadableData.push(downloadableObj);
                }
                tableObj.total = total;
                tableObj.reOpenCount = reOpenCount;
                tableObj.percentage = isNaN((((total - reOpenCount) *100 ) / total).toFixed(2)) ? 0 : (((total - reOpenCount) *100 ) / total).toFixed(2);
                tableObj.expandedItems = expandedTable;
                tableData.push(tableObj);
                summaryData.reOpenCount = summaryData.reOpenCount + tableObj.reOpenCount;
                summaryData.percentage = parseInt(summaryData.percentage) + parseInt(tableObj.percentage);
            }
            summaryData.reOpenCount = summaryData.reOpenCount;
            summaryData.percentage = summaryData.percentage / buckets.length;
        }
        return {tableData, graphData, summaryData, downloadableData};
    };

    const getReopenCountSLA = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            let formattedData = [];
            setReopenCountLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETREOPENCOUNTSLA, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareReopenCountSLAData(resp);
                setReopenCountSLAData(formattedData.graphData);
                setReopenCountSLATable(formattedData.tableData);
                setReopenCountSummary(formattedData.summaryData);
                setReopenCountDownloadabelData(formattedData.downloadableData);
                setReopenCountLoading(false);
            }).catch((error) => {
                setReopenCountLoading(false);
            });

        }
    }

    const getIncidentBreakfix = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setBreakfixLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP,dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETINCIDENTBREAKFIX, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                setBreakfixData(resp);
                setBreakfixLoading(false);
            }).catch((error) => {
                setBreakfixLoading(false);
            });
        }
    }

    const preparePerformanceTrendData = (response) => {
        let graphData = [];
        let tableData = [];
        let tableObj = {};
        let graphObj = {};
        let headersObj = [];
        let headerResult = [];
        let headers = [
            {
                key: 'week',
                header: DashboardConstants.TimePeriod
            },
            {
                key: 'total',
                header: DashboardConstants.Total
            }
        ];
        if (response) {
            let buckets = response.aggregations.incident_trend.buckets;
            for (let i = 0; i < buckets.length; i++) {
                tableObj = {
                    id: buckets[i].key,
                    week: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                    total: buckets[i].doc_count
                };
                for (let j = 0; j < buckets[i].incident_status.buckets.length; j++) {
                    graphObj = {
                        group: buckets[i].incident_status.buckets[j].key,
                        date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                        value: buckets[i].incident_status.buckets[j].doc_count,
                    };
                    headersObj.push({ key: buckets[i].incident_status.buckets[j].key, header: buckets[i].incident_status.buckets[j].key });
                    tableObj[buckets[i].incident_status.buckets[j].key] = buckets[i].incident_status.buckets[j].doc_count;
                    graphData.push(graphObj);
                }
                tableData.push(tableObj);
                headerResult = headersObj.filter((v, i, a) => a.findIndex(t => (t.key === v.key)) === i);
            }
        }
        headers = headers.concat(headerResult);
        setPerformanceTrendTableHeaders(headers);
        return { tableData, graphData };
    };

    const getIncidentPerformanceTrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP,dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETINCIDENTPERFORMANCETREND, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = preparePerformanceTrendData(resp);
                setPerformanceTrendGraphData(formattedData.graphData);
                setPerformanceTrendTableData(formattedData.tableData);
                setPerformanceTrendLoading(false);
            }).catch((error) => {
                setPerformanceTrendLoading(false);
            });
        }
    }

    const prepareIncidentAgeingData = (response) => {
        let graphData = [];
        let tableData = [];
        let tableObj = {};
        let graphObj = {};
        let expandedItemObj = {};
        let expandedTable = [];
        let summaryData = 0, total = 0, days = 0;
        let downloadableData = [];
        let downloadableObj = {};
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            for (let i = 0; i < buckets.length; i++) {               
                expandedTable = [];
                total = 0;
                days = 0;
                tableObj = {
                    id: i+1,
                    item: buckets[i].key
                }
                for (let j = 0; j < buckets[i]["3"].buckets.length; j++) {
                    total =  total + buckets[i]["3"].buckets[j].doc_count;
                    days = days + Math.round(buckets[i]["3"].buckets[j]["1"].value)
                    expandedItemObj = {
                        id: j+1,
                        item: buckets[i]["3"].buckets[j].key,
                        total: buckets[i]["3"].buckets[j].doc_count,
                        days: Math.round(buckets[i]["3"].buckets[j]["1"].value)
                    };
                    graphObj = {
                        group: buckets[i]["3"].buckets[j].key,
                        key: buckets[i].key,
                        value: buckets[i]["3"].buckets[j]["1"].value,
                    };
                    downloadableObj = {
                        priority: buckets[i]["3"].buckets[j].key,
                        item: buckets[i].key,
                        days: buckets[i]["3"].buckets[j]["1"].value,
                        total: buckets[i]["3"].buckets[j].doc_count,
                    }
                    graphData.push(graphObj);
                    expandedTable.push(expandedItemObj);
                    downloadableData.push(downloadableObj);
                }               
                tableObj.total = total;
                tableObj.days = isNaN(days / expandedTable.length) ? 0 : (days / expandedTable.length).toFixed(2);
                tableObj.expandedItems = expandedTable;
                tableData.push(tableObj);
                summaryData = summaryData + parseFloat(tableObj.days);
            }
            summaryData = isNaN(summaryData / buckets.length) ? 0 : (summaryData / buckets.length);
        }
        return { tableData, graphData, summaryData, downloadableData };
    };

    const getIncidentAgeing = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
            setIncidentAgeingLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            callPostApi(Constants.GETINCIDENTAGING, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareIncidentAgeingData(resp);
                setIncidentAgeingData(formattedData.graphData);
                setIncidentAgeingTable(formattedData.tableData);
                setIncidentAgeingSummary(formattedData.summaryData);
                setIncidentAgeingDownloadableData(formattedData.downloadableData);
                setIncidentAgeingLoading(false);
            }).catch((error) => {
                setIncidentAgeingLoading(false);
            });

        }
    }

    return (
        <div className="top-margin dashboard incident-management">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={incidentAgeingLoading && reopenCountLoading} summary={incidentManagementSummary} title={DashboardConstants.IncidentManagementEfficiencySummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <DashboardLineChart
                            lineGraphData={performanceTrendGraphData}
                            loading={performanceTrendLoading}
                            graphTitle={DashboardConstants.TotalTickets}
                            title ={DashboardConstants.PerformanceTrendTicketData}
                        />
                        <div className="bold-border-table">
                            <DashboardTable loading={performanceTrendLoading} rows={performanceTrendTableData} headers={PerformanceTrendTableHeaders}
                            showPagination={true} />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={incidentAgeingLoading}
                                    title={DashboardConstants.IncidentAgeingSLAReport}
                                    groupedBarChartData={incidentAgeingData}
                                    downloadableData={incidentAgeingDownloadableData}
                                    graphAxesTitle={DashboardConstants.AvgIncidentAgeing} //"Avg Incident Ageing (days)"
                                    graphBottomTitle={DashboardConstants.Franchise}
                                    headers={IncidentManagementTables.incidentAgingDownloadableHeaders}
                                />
                                <div className="bold-border-table nested-table">
                                    <DashboardTable loading={incidentAgeingLoading} rows={incidentAgeingTable} headers={IncidentManagementTables.incidentAgingTableHeaders}
                                    showPagination={true} isSortable={true} isExpandable={true} />
                                </div>
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={reopenCountLoading}
                                    title={DashboardConstants.FirstTimeResolution}// "% First Time Resolution"
                                    graphAxesTitle={DashboardConstants.AvgIncidentAgeingResolvedTickets}//"Avg Incident Ageing resolved tickets"
                                    graphBottomTitle={DashboardConstants.Franchise} 
                                    groupedBarChartData={reopenCountSLAData}
                                    headers={IncidentManagementTables.reopenCountDownloadableTableHeaders}
                                    downloadableData={reopenCountDownloadabelData}
                                    isPercentage={true}
                                />
                                <div className="bold-border-table nested-table">
                                    <DashboardTable loading={reopenCountLoading} rows={reopenCountSLATable} headers={IncidentManagementTables.reopenCountTableHeaders}
                                    showPagination={true} isSortable={true} isExpandable={true} />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardCirclePackChart
                                    loading={severityWiseIncidentLoading}
                                    circlePackChartData={severityWiseIncidentData}
                                    downloadableData={severityWiseIncidentDownloadableData}
                                    title={DashboardConstants.SeverityWiseIncidentStatus}
                                />
                                <div className="bold-border-table nested-table severity-wise-incident-table" style={{marginLeft:'15px'}}>
                                    <DashboardTable loading={severityWiseIncidentLoading} rows={severityWiseIncidentTableData} headers={IncidentManagementTables.severityWiseTableHeaders}
                                    showPagination={true} isSortable={true} isExpandable={true} />
                                </div>
                            </div>
                            <div className="report-container">
                                {!breakfixLoading && <Breakfix breakfixData={breakfixData} loading={breakfixLoading} />}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default IncidentManagement;
